import videojs from 'video.js';

window.VIDEOJS_NO_DYNAMIC_STYLE = true;

const video = {
  player: '',
  clips: document.getElementsByClassName('js-clip'),
};

export default function InitClips() {
  if (video.clips) {
    for (let i = video.clips.length - 1; i >= 0; i -= 1) {
      videojs(video.clips[i]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/modules/clips.js